import { store as group } from './group'
import { store as course } from './course'
import { store as shift } from './shift'
import { store as company } from './company'
import { store as ambience } from './ambience'
import { store as hour } from './hour'
import { store as workTime } from './worktime'
import { store as signature } from './signature'
import { store as access } from './access'
import { store as grid } from './grid'
import { store as communication } from './communication'
import { store as occurrence } from './occurrence'
import { store as integration } from './integration'
import { store as dynamics } from './dynamics'
import { store as teacher} from './teacher'
import { store as agent } from './agent'
import { store as arp } from './arp'
import { store as learningPath } from './learning-path'
import { store as cenarioCatalogo } from './cenario-catalogo'
import { store as dynamicCalendar } from './dynamic-calendar'
import { store as catalogoGrade } from './catalogo-grade'

export default {
    ...group,
    ...course,
    ...shift,
    ...company,
    ...ambience,
    ...hour,
    ...workTime,
    ...signature,
    ...access,
    ...grid,
    ...communication,
    ...occurrence,
    ...integration,
    ...dynamics,
    ...teacher,
    ...agent,
    ...arp,
    ...learningPath,
    ...cenarioCatalogo,
    ...dynamicCalendar,
    ...catalogoGrade,
}